<template>
  <div class="h-full">
    <el-row type="flex" justify="center" align="middle" class="h-full">
      <el-card class="login-card">
        <el-row type="flex" justify="center" align="middle" class="h-full">
          <img :src="require('assets/logo.png')" class="logo" />
        </el-row>
        <el-form
          ref="form"
          :model="form"
          @keyup.enter.native="login"
          size="medium"
          label-width="100px"
        >
          <el-form-item label="Usuario" class="login-form-item">
            <el-input
              v-el-focus
              v-model="form.username"
              id="login-user-input"
            />
          </el-form-item>
          <el-form-item label="Contraseña" class="login-form-item">
            <el-input
              v-model="form.password"
              type="password"
              id="login-password-input"
            />
          </el-form-item>
          <div style="text-align: right">
            <el-button
              class="btn-primary"
              @click="login"
              :loading="loading"
              id="login-enter-button"
              >Ingresar</el-button
            >
          </div>
        </el-form>
      </el-card>
    </el-row>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars

export default {
  computed: {
    loading: sync("authentication/loading"),
    globalParameters: get("config/globalParameters"),
    loginRedirectRoute() {
      return (this.globalParameters && this.globalParameters["loginPath"]) 
        ? this.globalParameters["loginPath"] 
        : "Dashboard";
    },
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      components: null,
    };
  },
  props: { componentsMap: {} },
  created: function () {
    var VueCookie = require("vue-cookie");
    var authentication = VueCookie.get("pc_authentication");
    if (authentication) {
      this.$router.push({ name: this.loginRedirectRoute });
    }
  },
  methods: {
    login() {
      var vm = this;
      vm.loading = true;
      vm.$store
        .dispatch("authentication/login", {
          username: vm.form.username,
          password: vm.form.password,
        })
        .then(() => {
          vm.$emit("logged");
          vm.buildComponentsMap().then(function () {
            vm.$router.push({ name: vm.loginRedirectRoute });
          });
        })
        .catch(() => {
          vm.$notify.error({
            title: vm.i18nValues["error"],
            message: "Usuario y/o contraseña incorrecto.",
            position: "bottom-right",
            duration: 5200,
          });
        })
        .then(() => {
          vm.form.password = "";
        })
        .finally(() => {
          vm.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-card {
  background-color: #f0f0f0;
}
.logo {
  margin-bottom: 20px;
  //filter: invert(59%) sepia(46%) saturate(2031%) hue-rotate(143deg)
   //brightness(93%) contrast(92%);
    width: 50 ;
    height: 48px !important;
}
.login-form-item {
  margin-bottom: 22px !important;
}
.login-card {
  width: 440px;
}
.el-form-item {
  display: block !important;
  flex-direction: unset !important;
  align-items: unset !important;
}
.el-form .login-form-item /deep/ label {
  font-size: 14px !important;
  line-height: 36px !important;
  text-align: right !important;
}
.el-form-item {
  margin-top: 0px !important;
}
.el-form .login-form-item /deep/ label {
  padding: unset !important;
  padding-right: 12px !important;
  margin: unset !important;
  margin-bottom: 8px !important;
  min-width: unset !important;
}
</style>